import { useContext } from 'react';
import { eventsContext } from '../contexts/EventsContext';

export function useEvents() {
  const value = useContext(eventsContext);
  return value;
}
